import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ScoreboardService} from "../services/scoreboard.service";
import {HelperService} from "../services/helper.service";
import {SocketService} from "../services/socket.service";


@Component({
  selector: 'app-scoreboard',
  templateUrl: './scoreboard.component.html',
  styleUrls: ['./scoreboard.component.css']
})
export class ScoreboardComponent implements OnInit {
  connection;
  routeParams;

  constructor(private route: ActivatedRoute, private router: Router,
              private ss: ScoreboardService, private helperService: HelperService, private socketService: SocketService) {
  }

  ngOnInit() {
    this.routeParams = this.route.params.subscribe((params) => {
      this.ss
        .getLastScoreboardData(+params['id'])
        .subscribe(message => {
          this.socketService.sendTopic(+params['id']);
          if (!this.helperService.isEmpty(message)) {
            this.helperService.redirectToComponent(message, this.router, params);
          }
          this.connection = this.socketService.messages().subscribe(message => {
            if (!this.helperService.isEmpty(message)) {
              this.helperService.redirectToComponent(message, this.router, params);
            }
          });

        });
    });
  }

  ngOnDestroy(): void {
    this.connection.unsubscribe();
    this.routeParams.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/scoreboard/scoreboard.component.ts